const types = {
    SET_RX_ERRORS: 'SET_RX_ERRORS',
    SET_RX_REQUESTS: 'SET_RX_REQUESTS',
    SET_IS_LOADING: 'SET_IS_LOADING'
};

export default types;